module.exports = __webpack_public_path__ + "media/images/emblems/Rickenbach-blazon-00526393027e3486e22abae676a5a14c.svg";